import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import ListItem from '@material-ui/core/ListItem'
import IconButton from '@material-ui/core/IconButton'
import MoreVert from '@material-ui/icons/MoreVert'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import Avatar from '@material-ui/core/Avatar'
import classNames from 'classnames'
import { styles } from './Panel'
import './skeletonPulse.css'

export default withStyles(styles)(({ classes }) => (
  <ListItem
    className={classNames(classes.panel, 'contact-expansion-panel')}
    classes={{ container: classes.container }}
  >
    <div className={classes.panelContent}>
      <div className={classes.left}>
        <Avatar
          classes={{
            root: classes.avatarRoot,
            colorDefault: classes.colorDefault,
          }}
        />
      </div>
      <div className={classes.heading}>
        <div className={classNames('skeleton', 'skeletonName')} />
      </div>
      <div className={classes.secondaryHeading}>
        <div className={classNames('skeleton', 'skeletonDetail')} />
      </div>
    </div>
    <ListItemSecondaryAction>
      <IconButton className={classes.button}>
        <MoreVert />
      </IconButton>
    </ListItemSecondaryAction>
  </ListItem>
))
